export default __webpack_public_path__ + "static/media/phone_logo.a269000d.webp";